import type { CSSValue } from '../syntax/parser';
import type { DimensionToken, NumberValueToken } from '../syntax/tokenizer';
import { TokenType } from '../syntax/tokenizer';

export type Length = DimensionToken | NumberValueToken;

export const isLength = (token: CSSValue): token is Length =>
  token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
